<template>
  <div class="outerDiv" :style="configStyle">
      <header_default v-if="layout=='default'" class="header"/>
     

      <loginuser ref="loginuser" v-if="!loggedIn" @loggedin="afterlogin" />
       
      <div  v-if="loggedIn && businessDayId!=-1">
          <main_default v-if="layout=='default'"/>


      </div>


      
  </div>
</template>

<script>

import {mapFields} from 'vuex-map-fields'
 import securityhelper from '../services/securityhelper.js'
import datamethods from '../services/datamethods.js'
import format from '../style/format.js'
import style from '../style/style.js'
import loginuser from '../components/login/loginuser.vue'

import pos from '../services/pos.js'
import header_default from './layouts/header_default.vue'
import header_culinary from './layouts/header_culinary.vue'
import main_default from './layouts/main_default.vue'
import main_culinary from './layouts/main_culinary.vue'
import footer_culinary from './layouts/footer_culinary.vue'

import main_culinarymobile from './layouts/main_culinarymobile.vue'
import header_culinarymobile from './layouts/header_culinarymobile.vue'
export default {
    components:{

        
        loginuser,
        header_default,
        header_culinary,
        main_default,
        main_culinary,
        footer_culinary,
        main_culinarymobile,
        header_culinarymobile
    },
    mixins:[ format,style, datamethods,pos,securityhelper],
    computed:{
        ...mapFields([
            'loggedInUser',
            'username',
            'oldpassword',
            'loggedIn',
            'location',
            'pleaseWait',
            'businessDayId',
            'terminalId',
            'responseMessage',
            'receiptIP',
            'imageBasePath',
            'needsUpdate',
            'IsAdmin'
 
        ]),
        
    },
    data(){
        return{

        }
    },
    methods:{
      
   

        afterlogin(){
          this.checkLastUpdate()
          this.IsAdmin=this.canAccess("POSAllServers")
        },
        getImageBasePath(){
            this.imageBasePath = window.VUE_CONFIG_API + 'personimage/'
        },
        receiveMessage(event){
            try{
                var msg =  JSON.parse(event.data)
            }
            catch(err){
                return
            }
            
            var action = msg.action
            if(action !=undefined){
                switch (action) {
                    case 'refresh':
                        break;
                    case 'appupdate':
                        location.reload(true);
                    default:
                        break;
                }
                
            }
      },
      async checkLastUpdate(){
        var needsClear =false

        //get the last update value from config
        var lastUpdate = '' 
        //if(window.LAST_UPDATE_DATE!=undefined){lastUpdate=window.LAST_UPDATE_DATE}

        //from api
        try {
          var response = await this.callAPI(null,'lastupdatedate')
            //handle response
            if(response.Successful){
              lastUpdate = response.StringResponse
 
            }

        } catch (error) {
          
        }
        
        
        //if we don't have a setting, then don't do anything
        if(lastUpdate==''){return}


        //get last update value from localstorage
        var storedLastUpdate = ''
        storedLastUpdate=localStorage.getItem('lastUpdate')

        console.log('lastupdate ' + lastUpdate + ' ' + storedLastUpdate)

        if(storedLastUpdate==undefined){needsClear=true}
        else if(storedLastUpdate!=lastUpdate){needsClear=true}

        //if we need to clear...
        if(needsClear){

          //set flag in store
          this.needsUpdate=true
        }
        
        //store the last update
        localStorage.setItem('lastUpdate',lastUpdate)

      }
    },
    
    mounted(){
      //to receive msgs
      window.addEventListener('message', this.receiveMessage)

      //fix favicon and title
      if(window.FAVICON!=undefined){
        const favicon = document.getElementById('favicon')
        favicon.href='./../' + window.FAVICON
      }
      if(window.PAGE_TITLE!=undefined){
        const pagetitle = document.getElementById('pagetitle')
        pagetitle.innerText=window.PAGE_TITLE
      }
      

        let urlParams = new URLSearchParams(window.location.search)
        let tmp = urlParams.get('email')
        if(tmp!=null){
            this.username = tmp;
        }

        let tmpp = urlParams.get('temp')
        if(tmpp!=null){
            this.oldpassword = tmpp;
            this.$nextTick(()=>{
            //this.changepass()
            this.$refs.loginuser.changepassword();
            });
        }

        let tmp2 = urlParams.get('location')
        if(tmp2!=null){
            this.location.id = tmp2;
        }

        let tmp3 = urlParams.get('terminal')
        if(tmp3!=null){
            this.terminalId = tmp3;
        }

        //receipt ip
        let tmp4 = urlParams.get('receipt')
        if(tmp4!=null){
            this.receiptIP = tmp4;
        }else{
          if(window.RECEIPT_IP!=undefined){
            this.receiptIP=window.RECEIPT_IP
          }
        }
     
        this.setColors();
        this.$store.dispatch('setupPanels')
        
        this.getImageBasePath();
        
        this.checkLastUpdate()
        this.getIpAddress()
    },
    
}
</script>

<style lang="scss">
@import "@/assets/stylebase.scss";

:root {
  --color-valid: rgb(128, 168, 128);
  --color-header-border: #13395d;
 

  --font-size-default: 14px;
  --font-size-biggest: 22px;
  --font-size-bigger: 18px;
  --font-color-default: black;
  --font-color-disabled: darkgray;


--background-color-disabled: lightgray;

  /* --background-color-default: white;
  --background-color-disabled: lightgray;
  --background-color-background: #c2b9b9;
  --background-color-inner: rgb(198, 205, 207);
  --background-color-inner-highlight: rgb(250, 246, 198);
  --background-color-button: #346278; /* #2c75aa; 
  --background-color-button-highlight: #8aa6b4; */

  --margin-default: 10px;
  --margin-bigger: 20px;
  --margin-smaller:5px;
  --margin-button: 10px 10px 20px 10px;

  --padding-default: 10px;
  --padding-mid:15px;
  --padding-bigger: 20px;
  --padding-smaller: 5px;

  --margin-none: 0px;

  --border-radius-default: 2px;
  --border-radius-less:0px;
  --border-radius-more:4px;
  --border-default: 1px solid #c2b9b9;
  --border-thick: 4px solid #c2b9b9;

  --box-shadow-default: 6px 6px 6px #6e6868;
  --box-shadow-smaller: 2px 2px 2px #6e6868;
}

/* full screen */
@media screen and (min-width: 812px) {
    .outerDiv{
      background-color:var(--background-color);
        margin:0px 0px 0px 0px;
        height:98vh;
        display:grid;
        grid-template-rows:170px auto auto;
        grid-template-areas: 
            "header"
            "center"
            "footer";
    }
    .entry{
        flex-direction: row;
    }

    
}
/* phone */
@media screen and (max-width: 812px) {
    .outerDiv{
        margin:0px 0px 0px 0px;
        height:100vh;
        display:grid;
        grid-template-rows:10px auto auto;
        grid-template-areas: 
            "header"
            "center"
            "footer";
    }
    .entry{
        flex-direction: column;
    }
    
}
.header{
    grid-area:header
}
.footer{
  grid-area:footer
}




.rightstack {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin: 0px 10px 60px 10px;
  color: var(--color-header-border);
}

.guest {
  grid-area: guest;
}
.lineitem {
  grid-area: cart;
}
.action {
  grid-area: action;
}
.payment {
  grid-area: payment;
}
.history {
  grid-area: history;
}

/*PANELS*/
.panel {
  border-radius: var(--border-radius-more);
  padding: var(--padding-default);
  background-color: var(--frame-color);
}
.panel-inactive {
  margin: 10px 20px 10px 10px;
}
.panel-active {
  margin: 10px -10px 10px 10px;
  border: var(--border-default);
  box-shadow: var(--box-shadow-default);
}

.panel-valid {
  border-style: solid;
  border-color: var(--color-valid);
  border-width: 0px 0px 0px 15px;
  /* puts green bar to left of tab */
}
.panel-invalid {
  background-color: var(--frame-color);
  border-color: var(--frame-color);
  border-width: 0px 0px 0px 15px;
}
.panel-unavailable {
  background-color: var(--background-color-disabled);
  color: var(--font-color-disabled);
}
.panel-full {
  grid-area: full;
  background-color: var(--frame-color);
  margin: 10px 10px 10px 0px;
  padding: var(--padding-bigger);
  box-shadow: var(--box-shadow-default);
}
.panel-inner {
  padding: var(--padding-default);
  margin: var(--margin-default);
  border: var(--border-default);
  border-radius: var(--border-radius-default);
  // box-shadow: var(--box-shadow-smaller);
  //background-color: var(--background-color-inner);
}
.color-inner{
  //background-color: var(--background-color-inner);
  border: var(--border-default);
}
.color-highlight{
 // background-color: var(--background-color-inner);
  border: var(--border-thick);
  border-color:var(--button-color);
  //font-weight: bolder;
}
/* input:focus{
    border:1px solid var(--highlight-color);
    outline:none;
  } */
.scroll{
  height:80%;
    overflow-x:hidden;
    overflow-y:scroll;
}
/*BUTTONS*/
.btn {
  background-color: var(--button-color);
  color: var(--light-text-color);
  margin: var(--margin-default);
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-bigger);
  
}
.btn-red{
  background-color:red;
  color: var(--light-text-color);
  margin: var(--margin-default);
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-smaller);
}
.btn-red-fixed{
  background-color:red;
  color: var(--light-text-color);
  margin: var(--margin-default);
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-smaller);
  // width:120px;
}
.btn-small {
  background-color: var(--button-color);
  color: var(--light-text-color);
  margin: var(--margin-default);
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-smaller);
}
.btn:hover {
  background-color: var(--highlight-button-color);
}
.btn-small:hover {
  background-color: var(--highlight-button-color);
}
.paymentbutton {
  background-color: var(--color-payment);
  color: var(--light-text-color);
  min-width:120px;
}
.cashpaymentbutton{
  background-color: var(--color-cash);
  color: var(--light-text-color);
  min-width:120px;
}
.nextbutton {
  grid-area: next;
  text-align: right;
}
  .btnsplit {
  background-color: var(--button-color);
  color: var(--light-text-color);
  margin: var(--margin-default);
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-default);
  height:35px;
}
  .paymentbuttonsplit {
  background-color: var(--color-payment);
  color: var(--light-text-color);
  min-width:100px;

}
.cashpaymentbuttonsplit{
  background-color: var(--color-cash);
  color: var(--light-text-color);
  min-width:100px;

}

/*TEXT*/
.text {
  margin: var(--margin-default);
  font-size: var(--font-size-default);
}
.title {
  margin: var(--margin-default);
  font-size: var(--font-size-bigger);
}
.subtitletab{
  font-size: var(--font-size-default);
}
.subtitletabalert{
  font-size: var(--font-size-default);
  color:red;
}
.subtitle {
  font-size: var(--font-size-bigger);
}
.text-right {
  text-align: right;
}
.bold {
  font-weight: bold;
}
hr {
  color: var(--inactive-color);
}

/*IMAGES*/
.headerimage {
  width: 50%;
  margin: var(--margin-bigger);
}

/*TEXTBOXES*/
.textbox {
  font-size: inherit;
  margin: var(--margin-default);
  border-radius: var(--border-radius-default);
}

/*TABLES*/
table,
th,
td {
  border: var(--border-default);
  padding: var(--padding-default);
  font-weight: normal;
}
td {
  text-align: center;
}
th {
  font-size: var(--font-size-bigger);
}
table {
  border-collapse: collapse;
  margin: var(--margin-default);
  width: 92%;
}


.totaltext{
  font-size:larger;
  
}
.paycolor{
  color:var(--color-payment);
  font-weight:bold;
}
.discountcolor{
  color:red;
}
.eligiblemessage{
  color:var(--color-payment);
}
.fireimg{
  height:17px;
  margin-left:2px;
}
</style>